export const getFileFieldSubtitle = (fileType: string) => {
  return `Выберите файлы формата .${fileType.toUpperCase()}`;
};
